import { AssessmentPublishingStatus } from "api/api-types-assessment";
import { t } from "i18n/i18n";

export const getHomeAssessmentPublishLabel = (
  publishing: AssessmentPublishingStatus,
  isAssessmentComplete: boolean,
  isMarkedComplete: boolean,
): string => {
  if (publishing === AssessmentPublishingStatus.draft) {
    return t("publishing.unpublished");
  }

  if (isAssessmentComplete || isMarkedComplete) {
    return t("publishing.published");
  }

  return t("publishing.partial");
};

/** Groups assessment rows by section_id, preserving first-seen section order. */
export const groupAssessmentRowsBySectionId = <T extends { section_id: string }>(
  rows: T[],
): Map<string, T[]> => {
  const pagesBySectionId = new Map<string, T[]>();

  for (const row of rows) {
    const existing = pagesBySectionId.get(row.section_id);
    if (existing) {
      existing.push(row);
    } else {
      pagesBySectionId.set(row.section_id, [row]);
    }
  }

  return pagesBySectionId;
};

/**
 * Non-empty sections in API/first-seen order, then empty section ids (already title-sorted).
 */
export const orderHomeAssessmentSectionIds = (
  pagesBySectionId: Map<string, unknown>,
  allSectionIdsForTerm: string[],
): string[] => {
  const sectionIdsWithPages = [...pagesBySectionId.keys()];
  const sectionIdsWithPagesSet = new Set(sectionIdsWithPages);
  const emptySectionIds = allSectionIdsForTerm.filter(
    (sectionId) => !sectionIdsWithPagesSet.has(sectionId),
  );
  return [...sectionIdsWithPages, ...emptySectionIds];
};
